/**
 * File size limits for images
 * These constants should match the backend model validations
 */

// Maximum image file size in MB (matching backend constant)
export const MAX_IMG_FILE_SIZE_MB = 10; // Images

// Maximum image file size in bytes for frontend validation
export const MAX_IMG_FILE_SIZE_BYTES = MAX_IMG_FILE_SIZE_MB * 1024 * 1024;

// User-friendly error message for frontend display
export const FRIENDLY_IMAGE_SIZE_ERROR = `Images must be less than ${MAX_IMG_FILE_SIZE_MB}MB.`;
